
export const TEMPLATE = `<ng-content></ng-content>`;


